module.exports = __webpack_public_path__ + "static/img/j-4.c5f91827.png";